import { render } from "./QuickViewField.vue?vue&type=template&id=04aea95c&scoped=true&lang=pug"
import script from "./QuickViewField.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickViewField.vue?vue&type=script&setup=true&lang=js"

import "./QuickViewField.vue?vue&type=style&index=0&id=04aea95c&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04aea95c"]])

export default __exports__